// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { type AccountsHoldingsData } from '@shared/data-access/interfaces/api/brokerage/brokerage';
import produce from 'immer';

export const buildAccountBreakdown = (data: AccountsHoldingsData[]) => {
  const assets = produce(data, draft => {
    draft.sort((a, b) => b.weight - a.weight);
  });

  const topBreakdownAssets = assets.slice(0, 5);

  const otherBreakdownAssets = assets
    .slice(5)
    .reduce((acc, { weight }) => acc + weight, 0);

  const result = topBreakdownAssets.concat(
    topBreakdownAssets.length
      ? ({
          name: 'Others',
          weight: otherBreakdownAssets,
          institution_id: '',
          institution_name: '',
          price: -1,
          quantity: -1,
          investment: -1,
          currency: '',
          asset_type: '',
          asset_class: '',
          details: null,
          subRows: [],
          iban: '',
        } as AccountsHoldingsData)
      : [],
  );

  return result;
};
